const BaseError = require('make-error').BaseError;

class InvalidTokenError extends BaseError {
    constructor(errorMessage='Invalid Token.') {
        super(errorMessage);
    }
}

module.exports = InvalidTokenError;
